import { red } from '@material-ui/core/colors';
import { createMuiTheme } from '@material-ui/core/styles';
// Custom Theme for Trivia Weekend
const createAppTheme = (primaryColor = '#55d685') => createMuiTheme({
    overrides: {
        MuiFormLabel: {
            root: {
                "&$focused": {
                    color: 'white'
                }
            }
        }
    },
    palette: {
        primary: {
            main: primaryColor,
        },
        secondary: {
            main: '#fff',
        },
        success: {
            main: '#55d685',
        },
        error: {
            main: red.A400,
        },
        background: {
            default: '#2f2929',
        },
        text: {
            default: '#fff',
        },
    },
    typography: {
        fontFamily: '"Space Grotesk", "Helvetica Neue", Arial, sans-serif',
        fontWeightLight: 200,
        fontWeightRegular: 300,
        fontWeightMedium: 400,
    },
    // formControl: {
    //     color: "white"
    // }
});

export default createAppTheme;
